/**
 * Durées de conservation annoncées à l'écran.
 *
 * <p>Les photos d'un chantier « Terminé » sont supprimées {@link PHOTO_ANS} ans
 * après sa fin par un traitement du serveur (`PurgePhotosChantiers`, actif par
 * défaut ; son premier passage sur une instance est à blanc). Les factures et documents
 * comptables, eux, ne sont jamais purgés.
 */

/** Années de conservation des photos après la fin du chantier (même valeur côté serveur). */
export const PHOTO_ANS = 7;

/** Années de conservation des factures et documents comptables. */
export const DOCUMENTS_ANS = 15;
